import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Btn from '../../../../../components/Buttons/Btn';
import ModalCreateAudience from '../../../Registrations/Audience/Components/ModalCreate/CreateAudienceModal';
import SelectAsyncJSX from '../../../../../components/SelectAsync';
import { audienceAPI } from '../../../../../services/requests';
import { Audience } from '../../../../../types';
import { getOptionsFromAudiences, SelectOption } from '../../../../../utils/getSelectOptions';
import * as s from '../styles';

type Props = {
  value: SelectOption | null;
  onChange: (value: SelectOption | null) => void;
  disabled?: boolean;
};

const AudienceSelectWithCreate = ({ value, onChange, disabled = false }: Props) => {
  const { t } = useTranslation();
  const [showAudienceModal, setShowAudienceModal] = useState(false);
  const [audienceCache, setAudienceCache] = useState(0);

  const handleAudienceCreated = (createdAudience?: Audience) => {
    if (createdAudience?.id !== undefined && createdAudience.description) {
      onChange({
        value: createdAudience.id,
        label: createdAudience.description,
      });
    }

    setAudienceCache((cache) => cache + 1);
    setShowAudienceModal(false);
  };

  return (
    <>
      <s.AudienceRow>
        <s.Field>
          <s.FieldLabel htmlFor="access-block-audience">{t('audience')}</s.FieldLabel>
          <SelectAsyncJSX
            id="access-block-audience"
            value={value}
            onChange={(option: SelectOption | null) => onChange(option)}
            request={audienceAPI}
            reqResponseToOption={getOptionsFromAudiences}
            placeholder={t('selectAudience') as string}
            disabled={disabled}
            isRequired
            cacheUniqs={[audienceCache]}
          />
        </s.Field>
        <Btn
          text={t('newAudience') as string}
          type="outlined"
          onClick={() => setShowAudienceModal(true)}
          disabled={disabled}
          style={{ margin: 0 }}
        />
      </s.AudienceRow>

      {showAudienceModal && (
        <ModalCreateAudience
          closeModal={() => setShowAudienceModal(false)}
          callback={handleAudienceCreated}
        />
      )}
    </>
  );
};

export default AudienceSelectWithCreate;
